export let Currency;
(function (Currency) {
  Currency["ARS"] = "Argentina";
  Currency["AUD"] = "Australia";
  Currency["BRL"] = "Brazil";
  Currency["CAD"] = "Canada";
  Currency["CHF"] = "Switzerland";
  Currency["CLP"] = "Chile";
  Currency["CNY"] = "China";
  Currency["CZK"] = "Czech - NOT SUPPORTED IN APP";
  Currency["DKK"] = "Denmark";
  Currency["EUR"] = "Euro";
  Currency["GBP"] = "United Kingdom";
  Currency["HKD"] = "Hong Kong";
  Currency["ILS"] = "Israel";
  Currency["INR"] = "India";
  Currency["JPY"] = "Japan";
  Currency["KRW"] = "South Korea";
  Currency["MXN"] = "Mexico";
  Currency["MYR"] = "Malaysia - NOT SUPPORTED IN APP";
  Currency["NOK"] = "Norway";
  Currency["NONE"] = "none";
  Currency["NZD"] = "New Zealand";
  Currency["PHP"] = "Philippines - NOT SUPPORTED IN APP";
  Currency["PLN"] = "Poland - NOT SUPPORTED IN APP";
  Currency["RON"] = "Romania - NOT SUPPORTED IN APP";
  Currency["RUB"] = "Russia";
  Currency["SEK"] = "Sweden";
  Currency["SGD"] = "Singapore";
  Currency["TWD"] = "Taiwan - NOT SUPPORTED IN APP";
  Currency["USD"] = "United States";
  Currency["VND"] = "Vietnam - NOT SUPPORTED IN APP";
  Currency["YTL"] = "Turkey - NOT SUPPORTED IN APP";
  Currency["ZAR"] = "South Africa";
})(Currency || (Currency = {}));
//# sourceMappingURL=Currency.js.map